import { render, staticRenderFns } from "./AutonomousHeroesList.vue?vue&type=template&id=3c5a48fa&scoped=true&"
import script from "./AutonomousHeroesList.vue?vue&type=script&lang=js&"
export * from "./AutonomousHeroesList.vue?vue&type=script&lang=js&"
import style0 from "./AutonomousHeroesList.vue?vue&type=style&index=0&id=3c5a48fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a48fa",
  null
  
)

export default component.exports